<template>

  <div class="time">
    {{countDownText}}：<span class="day" v-if="this.countdown.days>=0">{{this.countdown.days}}</span>天
    <p>
      <span>{{countdown.hours.toString().split("")[0]}}</span>
      <span>{{countdown.hours.toString().split("")[1]}}</span>
      <span>:</span>
      <span>{{countdown.minutes.toString().split("")[0]}}</span>
      <span>{{countdown.minutes.toString().split("")[1]}}</span>
      <span>:</span>
      <span>{{countdown.seconds.toString().split("")[0]}}</span>
      <span>{{countdown.seconds.toString().split("")[1]}}</span>
    </p>
  </div>
</template>

<script>
export default {
  props: ["endTime", "countTo", "now", "countDownText"],
  data() {
    return {
      countdown: {
        days: "",
        hours: "",
        minutes: "",
        seconds: ""
      }
    }
  },
  mounted() {
    let now = ""
    if (this.now instanceof Date && !isNaN(this.now.valueOf())) {
      now = this.now?.getTime()
    } else {
      now = new Date().getTime()
    }
    this.setCountDownInterval(this.endTime * 1000 - now)
  },
  methods: {
    calCountDown(timediff) {
      let seconds = Math.floor((timediff / 1000) % 60)
      let minutes = Math.floor((timediff / 1000 / 60) % 60)
      let days = Math.floor(timediff / (1000 * 60 * 60) / 24)

      let hours = Math.floor((timediff / (1000 * 60 * 60)) % 24)

      let countdown = {
        days: days,
        seconds: seconds < 10 ? "0" + (seconds <= 0 ? "0" : seconds) : seconds,
        minutes: minutes < 10 ? "0" + (minutes <= 0 ? "0" : minutes) : minutes,
        hours: hours < 10 ? "0" + (hours <= 0 ? "0" : hours) : hours
      }
      this.countdown = countdown
      return timediff
    },
    setCountDownInterval(timediff) {
      let t = timediff
      this.calCountDown(timediff)
      let intervalTimer = setInterval(() => {
        // 得到剩余时间
        t = t - 1000
        let remainTime = this.calCountDown(t)

        if (remainTime <= 0) {
          clearInterval(intervalTimer)
        }
      }, 1000)
    }
  }
}
</script>

<style scoped>
</style>
